import i18n from "@/plugins/i18n"
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import { computed } from "vue";

const historicsGroup = ['access-historics']
const configsGroup = ['access-configs']
const cardsGroup = ['access-cards']

export default {
    menus:  computed(() => (
        {
            sectionTitle: i18n.global.t("menu.access.title"),
            module : [moduleAbilities.ACCESS],
            permission: [],
            children: [
                {
                    title: i18n.global.t('menu.access.accessConfig'),
                    icon: 'fas fa-lock icon-right2',
                    route: 'access-configs',
                    group: configsGroup,
                    id: 'step-configs',
                    permission: [abilities.CAN_VIEW_ACCESS_CONFIG],
                    children: [],
                    module: [moduleAbilities.ACCESS],
                },
                {
                    title: i18n.global.t('menu.access.historics'),
                    icon: 'fas fa-history icon-right2',
                    route: 'access-historics',
                    group: historicsGroup,
                    id: 'step-historics',
                    permission: [abilities.CAN_VIEW_ACCESS_HISTORICS],
                    children: [],
                    module: [moduleAbilities.ACCESS],
                },
                {
                    title: i18n.global.t('menu.access.cards'),
                    icon: 'fas fa-id-card icon-right2',
                    route: 'access-cards',
                    group: cardsGroup,
                    id: 'step-cards',
                    permission: [abilities.CAN_CARD_CONFIG_VIEW],
                    children: [],
                    module: [moduleAbilities.ACCESS],
                },
            ]
        }
    ))
}
